<template>
    <div class="bg_main">
        <v-row>
            <v-col cols="12">
                <v-card v-if="proceduresStore.procedureDataForm != null">
                    <v-card-title class="">
                        <v-container>{{processStore.processName}} (Trámite {{procedureMeta.tramite_id}})</v-container>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <!-- STEPPER ON HEADER -->
                            <TaskSteps :current-task="getCurrentStep()"/>

                            <!-- FORM CONTENT -->
                            <Form procedure-action="execute"/>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import {mapActions, mapState, mapGetters} from "vuex";
    import {procedureSubmitNextRequest, procedureTaskStepsRequest} from "../api/models";

    import Form from '../components/Procedure/Form'
    import TaskSteps from './../components/Procedure/TaskSteps'

    import * as Storage from '@/core/storage.js'
    import Constants from "@/core/constants";

    export default {
        data(){
          return {
              currentTask: 1
          }
        },
        components: {
            Form, TaskSteps
        },

        computed: {
            ...mapState({proceduresStore: state => state.procedures, processStore: state => state.processes}),
            ...mapGetters('procedures', ['procedureForm', 'procedureMeta'])
        },

        mounted() {
            /**
             * Si el componente fue llamado al dar siguiente en la ventanda de Creacion o Continuar
             * Si no (el usuario esta refrescando la pantalla)
            */
            if (this.proceduresStore.executingProcedure){
                this.initScreenElements()
            }else{
                this.initLoadingFormContent()
            }
        },

        watch: {
            '$store.state.procedures.procedureDataForm'(){
                this.initScreenElements()

            }
        },

        methods: {
            ...mapActions('procedures', ['createProcedure', 'getProcedureTaskSteps', 'getProcedureExecutedStep']),
            ...mapActions('processes', ['getProcessDetails']),

            /**
             * Busca la ultima URL usado para cargar el contenido del formulario para cargar todo desde cero
             * De lo contrario redireccion a la pagina de crear tramite
             */
            initLoadingFormContent(){
                let lastFormUrl = Storage.getItem(Constants.KEY_LAST_FORM_URL)
                let lastProcessExecuted = Storage.getItem(Constants.KEY_LAST_PROCESS_EXECUTED)

                if (lastFormUrl && lastProcessExecuted && lastProcessExecuted == this.$route.params.processId){
                    let request = procedureSubmitNextRequest()
                    request.processId = lastProcessExecuted
                    request.url = lastFormUrl

                    this.getProcedureExecutedStep(request)
                }else{
                    this.$router.push({name: 'procedure_create', params: {processId: this.$route.params.processId}})
                }
            },

            initScreenElements(){
                if (this.proceduresStore.procedureDataForm != null){
                    if (this.processStore.processName == null){
                        this.fetchProcessName()
                    }

                    this.fetchTaskSteps()
                }
            },

            fetchProcessName(){
                //Call from Vuex: Get process details
                this.getProcessDetails(this.procedureMeta.proceso_id)
            },

            fetchTaskSteps(){
                let request = procedureTaskStepsRequest()
                request.stageId = this.procedureMeta.etapa_id
                request.taskId = this.procedureMeta.tarea_id

                //Call from VueX: get task steps to show on Header
                this.getProcedureTaskSteps(request)
            },

            getCurrentStep(){
                let currentIndex = 0
                if (this.proceduresStore.taskSteps != null){
                    this.proceduresStore.taskSteps.forEach((step, index) => {
                        if (step.formulario_id == this.procedureMeta.formulario_id){
                            currentIndex = (index + 1)
                            return
                        }
                    })

                    if (currentIndex == 0 && this.proceduresStore.procedureDataForm.next_url != null ){
                        currentIndex = this.proceduresStore.taskSteps.length + 1
                    }
                }

                return currentIndex
            }

        }
    };
</script>

<style scoped>

</style>
